import Styleguide from "@store/Framework/Types/Styleguide";
import { buttonFieldIconClickableStyles, buttonFieldIconStyles } from "@store/Themes/common/mixins/button";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { css } from "styled-components";

const datePicker: Styleguide["datePicker"] = {
    defaultProps: {
        format: "MM/dd/yyyy", // Date Time: "MM/dd/yyyy hh:mm a"
        calendarIconProps: {
            color: "inherit",
            css: buttonFieldIconStyles(),
        },
        clearIconProps: {
            color: "inherit",
        },
        cssOverrides: {
            formField: null as any,
            datePicker: css`
                .react-datetime-picker {
                    &__calendar-button {
                        ${buttonFieldIconClickableStyles()}
                    }
                }

                .react-calendar {
                    box-shadow: ${x => x.theme.shadows.e60};

                    button {
                        transition: ${transitionHoverStyles("color", "background-color")};
                    }
                }
            `,
        },
    },
};

export default datePicker;
